/* eslint-disable @typescript-eslint/no-explicit-any */
import { Organization } from '@Types/api/common/dictionary';
import { Option } from '@Components/types/options';
import { TypeDict } from '@Types/index';
import { FormikProps } from 'formik';
import { MTag } from '@Components/Base';
import dayjs from 'dayjs';
import { parseDateTime } from '@Utils/transformDateTime';
import { getLabel } from './getLabel';

import { filterLabels } from '../constants';

export const getSimpleKeyTags = (
  keys: string[],
  formik: FormikProps<any>,
  attendanceTypes: TypeDict[],
  companies: Option[],
  workLocations: TypeDict[],
  overseasSponsors: TypeDict[],
  accessories: TypeDict[],
  itReqTypes: TypeDict[],
  organizations: Organization[],
  departments: Array<{ key: number; value: string }>,
  projects: Array<{ key: number; value: string }>,
  styles: {
    readonly [key: string]: string;
  }
): JSX.Element[] => {
  // Filter out internal fields that shouldn't be displayed as tags
  const filteredKeys = keys.filter((key) => key !== 'departmentType');

  return filteredKeys.map((key) => {
    const value = formik.values[key];

    const label = getLabel(
      key,
      value,
      attendanceTypes,
      companies,
      workLocations,
      overseasSponsors,
      accessories,
      itReqTypes,
      organizations,
      departments,
      projects,
      formik
    );
    const dateLabel =
      typeof value === 'object' && dayjs(value).isValid()
        ? parseDateTime(value)
        : null;

    const preparedValue = label || dateLabel || value.toString();

    const keyProp = `${key} ${preparedValue}`;

    return (
      <MTag
        key={keyProp}
        className={styles.tag}
        closable
        onClose={() => {
          formik.setFieldValue(key, '').then(() => {
            formik.handleSubmit();
          });
        }}
      >
        <span className={styles.title}>{`${filterLabels[key]} - `}</span>
        <span className={styles.value}>{preparedValue}</span>
      </MTag>
    );
  });
};
